import FixedTopNotification from 'components/FixedTopNotification/FixedTopNotification'
import  { useState } from 'react'
import { assumeAllowedRules, checkSameSectorAndLocation } from '../Header/Children/Buttons/AssumeTreatment'
import { UserDataType } from 'types/autentication'
import WithRoleAuthorization from 'components/WithRoleAuthorization/WithRoleAuthorization'
import { NotificationType } from 'types/notification'
import ExclamationIcon from 'components/Icons/ExclamationIcon'

export interface IAssumeTreatmentInfo {
  currentUser: UserDataType
  notificationLocation: string
  notificationSector: string
  notificationById: NotificationType
  handleAssumeNotification: () => void
}
export default function AssumeTreatmentInfo({ handleAssumeNotification,
  currentUser, notificationLocation,
  notificationSector, notificationById }: IAssumeTreatmentInfo) {
  const [showAssumeNotificationInfo, setShowAssumeNotificationInfo] = useState(true)

  const {isSameLocation,isSameSector} = checkSameSectorAndLocation({currentUser,
    notificationLocation,
    notificationSector
  })
  
  const loggedInUserIsResponsible =
  currentUser?.sys_id ===
  notificationById?.u_assigned_to?.value

  const notificationStatusShouldNotShow = ["Aguardando","Nova","Finalizada","Arquivada"]
  if (!notificationById||loggedInUserIsResponsible|| notificationStatusShouldNotShow.includes(notificationById?.u_state?.display_value)) {
    return null
  }
  return (
    <WithRoleAuthorization
      allowedRoles={assumeAllowedRules({ isSameLocation, isSameSector })}
      userRole={currentUser?.profile}
      children={
        <FixedTopNotification
        show={showAssumeNotificationInfo}
        handleClose={() => {
            setShowAssumeNotificationInfo(false)
        }}
  >
          <div className="flex items-center w-full text-center justify-center"
          data-testid="test-assume-treatment-info"
          >
          <div className="mr-1">
              <ExclamationIcon
              />
          </div>
          <span className="text-sm font-bold ">
              Essa notificação está em tratamento por outra
              pessoa. Para editar essa notificação você precisa{' '}
            <span
              onClick={handleAssumeNotification}
              className="text-blueTheme underline cursor-pointer">
                  assumir o tratamento
              </span>{' '}
              dela.
          </span>
      </div>
  </FixedTopNotification>
    }
/>
   
  )
}
